module.exports = __webpack_public_path__ + "static/media/galname.7e851ec8.png";